class QsStateManager {
  
  constructor() {
    this.params = [];
    this.paramMap = {
      np: 'minPrice',
      xp: 'maxPrice',
      br: 'bedrooms',
      ba: 'bathrooms',
      nf: 'minSquareFeet',
      xf: 'maxSquareFeet',
      nd: 'brand',
      ht: 'homeTypes',
      by: 'bays',
      fl: 'floors',
      qm: 'quickMoveIn',
      pc: 'mpcOnly',
      asc: 'asc',
      sb: 'sortBy'
    };
    return this;
  }

  addParam(paramName, paramValue, prevValue) {
    this.params.push({ paramName, paramValue, prevValue});
    return this;
  }

  addFilters(filters) {
    this.filters = filters;
    return this;
  }

  doUpdate() {
    const hist = window.history;
    if (hist && hist.pushState) {
      const url = new URL(window.location);
      const currentState = Object.assign({}, this.filters);
      const newState = Object.assign({}, this.filters);
      this.params.forEach(param => {
        url.searchParams.set(param.paramName, param.paramValue);
        if (param.prevValue) {
          currentState[param.paramName] = param.prevValue;
        }
        if (this.paramMap.hasOwnProperty(param.paramName)) {
          newState[this.paramMap[param.paramName]] = param.paramValue;
        } else {
          newState[param.paramName] = param.paramValue;
        }
      });
      history.replaceState(currentState, '');
      hist.pushState(newState, '', url);
    }
  }

  getSearchString() {
    const url = new URL(window.location)
    return url.search
  }

  goToNewPage(relativeUrl) {
    const url = new URL(window.location)
    url.pathname = relativeUrl
    this.params.forEach(param => {
      url.searchParams.set(param.paramName, param.paramValue);
    })
    window.location.href = url.href;
  }
}

export { QsStateManager };

const qstr = name => new URL(window.location).searchParams.get(name);

export { qstr };